/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Input,
  Grid,
  Button,
  Modal,
} from '../../components/index';
import {
  validateObject,
} from '../../utils/requests';
import * as listUtils from '../../utils/listsSelect';
import { checkUser } from '../../components/ComponentesAutenticacao/utils';

class Exigencia extends Component {
  constructor(props) {
    super(props);
    let estadoInicial;
    let dependentes = null;
    const exigenciaFiltrada = this.filtragemExigencia(props);
    if (props.dependentes) {
      dependentes = props.dependentes.map(dependente => (
        {
          label: dependente.nome,
          value: dependente.codigo,
        }
      ));
    }
    if (props.exigencia) {
      const exigenciaSelecionada = { ...props.exigencia };
      estadoInicial = {
        exigenciaFiltrada,
        exigenciaSelecionada,
        dependentes,
        touched: true,
        validadeCampos: {
          tipo: true,
        },
      };
    } else {
      estadoInicial = {
        exigenciaFiltrada,
        dependentes,
        exigenciaSelecionada: {
          abrangenciaAplicavel: null,
          acao: null,
          atendida: 0,
          tipo: null,
          comentario: null,
          index: null,
        },
        touched: false,
        validadeCampos: {
          tipo: false,
        },
      };
    }
    this.state = estadoInicial;
  }

  getInitialState = () => {
    const initialState = {
      touched: false,
      validadeCampos: {
        tipo: false,
      },
    };
    return initialState;
  }

  exigenciaValida = () => {
    const exigenciaDependenteValida = !(this.state.exigenciaSelecionada.abrangenciaAplicavel === 3
      && !this.state.exigenciaSelecionada.codigoDependente);
    const validadeCampos = { ...this.state.validadeCampos };
    return validateObject(validadeCampos) && exigenciaDependenteValida;
  }

  filtragemExigencia = (props) => {
    const EXIGENCIA_DE_SISTEMA = 2;
    let exigenciaFiltrada = [];
    // const userPermissions = checkUser(props.userData); // quem está logado no comprev
    // const logadoComoAnalistaRPPS = (userPermissions === 2);
    // CS_APLICACAO = abrangenciaAplicavel (1 APOSENTADORIA, 2 PENSAO)
    // CS_REGIME_APLICADO = regimeAplicavel (1 RGPS, 2 RPPS, 3 AMBOS)
    // CS_PARTICIPANTES = acordoAplicavel (1 RGPS-RPPS, 2 RPPS-RPPS, 3 AMBOS)
    // CS_PROPRIETARIO_EXIGENCIA = proprietario (1 Usuario, 2 Sistema)

    const isSolicitanteRGPS = props.solicitante.codigo === '01000';
    const isDestinatarioRGPS = props.destinatario.codigo === '01000';
    const reqParticipantes = (isSolicitanteRGPS || isDestinatarioRGPS) ? 1 : 2;
    const reqRegimeAplicado = isSolicitanteRGPS ? 1 : 2;
    const reqTipoRequerimento = (props.tipoRequerimento === 'aposentadoria') ? 1 : 2;
    exigenciaFiltrada = props.exigencias.filter(exigencia => (
      (
        (exigencia.regimeAplicavel === reqRegimeAplicado || exigencia.regimeAplicavel === 3) &&
        (reqParticipantes === exigencia.acordoAplicavel || exigencia.acordoAplicavel === 3) &&
        ((reqTipoRequerimento === exigencia.abrangenciaAplicavel) || (reqTipoRequerimento === 2 && exigencia.abrangenciaAplicavel === 3)) &&
        exigencia.proprietario !== EXIGENCIA_DE_SISTEMA
      )
    ));

    return exigenciaFiltrada;
  }

  handleButton = () => {
    const touched = true;
    this.setState({ ...this.state, touched }, this.handleAdicionarExigencia);
  }

  handleAdicionarExigencia = () => {
    if (this.exigenciaValida()) {
      this.props.salvaExigencia(this.state.exigenciaSelecionada);
    }
  }

  validateChange = (changeObj, name) => {
    let { exigenciaSelecionada } = { ...this.state };
    let abrangenciaAplicavel = null;
    let acao = null;
    let codigoDependente = null;
    if (name === 'tipo') {
      exigenciaSelecionada = changeObj.value ? listUtils.getObject(
        this.state.exigenciaFiltrada,
        changeObj.value,
      ) : null;
      // eslint-disable-next-line prefer-destructuring
      abrangenciaAplicavel = exigenciaSelecionada.abrangenciaAplicavel;
      acao = exigenciaSelecionada.label;
    } else {
      if (exigenciaSelecionada.abrangenciaAplicavel) {
        // eslint-disable-next-line prefer-destructuring
        abrangenciaAplicavel = exigenciaSelecionada.abrangenciaAplicavel;
      }
      // eslint-disable-next-line prefer-destructuring
      acao = exigenciaSelecionada.acao;
      // eslint-disable-next-line prefer-destructuring
      codigoDependente = exigenciaSelecionada.codigoDependente;
    }
    return ({
      abrangenciaAplicavel,
      acao,
      codigoDependente,
    });
  }

  handleChange = (changeObj, name) => {
    const exigenciaValidada = this.validateChange(changeObj, name);
    this.setState({
      exigenciaSelecionada: {
        ...this.state.exigenciaSelecionada,
        abrangenciaAplicavel: exigenciaValidada.abrangenciaAplicavel,
        acao: exigenciaValidada.acao,
        codigoDependente: exigenciaValidada.codigoDependente,
        [name]: changeObj.value,
      },
      validadeCampos: {
        ...this.state.validadeCampos,
        [name]: changeObj.isValid,
      },
    });
  }

  render() {
    let escolhaDependente = null;
    if (this.state.exigenciaSelecionada.abrangenciaAplicavel === 3) {
      escolhaDependente = (
        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              disabled={this.props.cumprimentoExigencia}
              itemList={this.state.dependentes}
              label="Escolha de dependente"
              number
              onChange={e => this.handleChange(e, 'codigoDependente')}
              placeholder="Selecione o dependente"
              required
              touched={this.state.touched}
              value={this.state.exigenciaSelecionada.codigoDependente}
              custom
            />
          </Grid>
        </div>
      );
    }
    let naoCumprimentoExigencia;
    if (this.state.exigenciaSelecionada.atendida === 2) {
      naoCumprimentoExigencia = (
        <React.Fragment>
          <Grid cols="6 6 6 6">
            <Input
              error={!this.state.validadeCampos.motivoNaoAtendimento}
              itemList={this.props.motivosNaoCumprimento}
              label="Tipo de atendimento"
              number
              onChange={e => this.handleChange(e, 'motivoNaoAtendimento')}
              placeholder="Selecione o motivo para o não atendimento"
              required
              touched={this.state.touched}
              value={this.state.exigenciaSelecionada.motivoNaoAtendimento}
              custom
            />
          </Grid>
          <Grid cols="12 12 12 12">
            <Input
              cols="74"
              componentClass="textarea"
              label="Comentário para não cumprimento"
              maxlength="600"
              onChange={e => this.handleChange(e, 'comentarioNaoAtendimento')}
              rows="3"
              value={this.state.exigenciaSelecionada.comentarioNaoAtendimento}
              textarea
            />
          </Grid>
        </React.Fragment>
      );
    }
    let atendimentoExigencia;
    if (this.props.cumprimentoExigencia) {
      atendimentoExigencia = (
        <div className="row">
          <Grid cols="6 6 6 6">
            <Input
              error={!this.state.validadeCampos.atendida}
              itemList={listUtils.tipoAtendimentoExigencia}
              label="Tipo de atendimento"
              number
              onChange={e => this.handleChange(e, 'atendida')}
              placeholder="Selecione o tipo de atendimento"
              required
              touched={this.state.touched}
              value={this.state.exigenciaSelecionada.atendida}
              custom
            />
            {naoCumprimentoExigencia}
          </Grid>
        </div>
      );
    }
    const modalContent = (
      <React.Fragment>
        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              disabled={this.props.cumprimentoExigencia}
              error={!this.state.validadeCampos.tipo}
              itemList={this.state.exigenciaFiltrada}
              label="Ação para cumprimento da exigência"
              number
              onChange={e => this.handleChange(e, 'tipo')}
              placeholder="Selecione a ação exigida"
              required
              touched={this.state.touched}
              value={this.state.exigenciaSelecionada.tipo}
              custom
            />
          </Grid>
        </div>
        {escolhaDependente}
        <div className="row">
          <Grid cols="12 12 12 12">
            <Input
              cols="74"
              componentClass="textarea"
              disabled={this.props.cumprimentoExigencia}
              label="Comentário"
              maxlength="600"
              onChange={e => this.handleChange(e, 'comentario')}
              rows="3"
              value={this.state.exigenciaSelecionada.comentario}
              textarea
            />
          </Grid>
        </div>
        {atendimentoExigencia}
      </React.Fragment>
    );
    const modalFooter = (
      <React.Fragment>
        <div className="right">
          <Button
            title="Cancelar"
            onClick={this.props.onHide}
            hint="Cancelar"
          />
          <Button
            className="dtp-primary"
            disabled={!this.exigenciaValida()}
            title={this.props.exigencia ? 'Salvar' : 'Adicionar'}
            onClick={this.handleButton}
            hint={this.props.exigencia ? 'Salvar exigencia' : 'Adicionar exigencia'}

            
          />
          
        </div>
      </React.Fragment>
      
      
    );
    return (
      <Modal
        {...this.props}
        conteudomodal={modalContent}
        conteudofooter={modalFooter}
        onHide={this.props.onHide}
        size={this.props.size}
      />
    );
  }
}

Exigencia.propTypes = {
  salvaExigencia: PropTypes.func,
  onHide: PropTypes.func,
}.isRequired;

export default Exigencia;



// WEBPACK FOOTER //
// ./src/pages/requerimentos/Exigencia.jsx